// Features data for the home page
export const features = [
  {
    icon: 'mdi:clock-fast',
    title: 'Time Saving',
    description:
      'Automate your procurement process and save hours every week with our streamlined ordering system.',
  },
  {
    icon: 'mdi:chart-line',
    title: 'Pricing Transparency',
    description:
      'Get real-time pricing, compare suppliers, and make informed decisions with complete cost visibility.',
  },
  {
    icon: 'mdi:message-text',
    title: 'Streamlined Communication',
    description:
      'Direct messaging with suppliers, automated notifications, and seamless order tracking all in one place.',
  },
];

// Hero statistics data for different user roles
export const restaurantStats = [
  {
    value: '500+',
    label: 'Suppliers',
    color: 'primary.main',
  },
  {
    value: '70%',
    label: 'Time Saved',
    color: 'primary.main',
  },
  {
    value: '24/7',
    label: 'Access',
    color: 'primary.main',
  },
];

export const supplierStats = [
  {
    value: '1000+',
    label: 'Restaurants',
    color: 'warning.main',
  },
  {
    value: '3x',
    label: 'Orders',
    color: 'warning.main',
  },
  {
    value: 'Real-time',
    label: 'Updates',
    color: 'warning.main',
  },
];

// Logos data for the home page
export const logos = [
  {
    name: 'Fresh Foods Co.',
    logo: '/assets/images/logos/fresh-foods.svg',
    type: 'Supplier',
  },
  {
    name: 'Urban Bistro',
    logo: '/assets/images/logos/urban-bistro.svg',
    type: 'Restaurant',
  },
  {
    name: 'Coastal Kitchen',
    logo: '/assets/images/logos/coastal-kitchen.svg',
    type: 'Restaurant',
  },
  {
    name: 'Premium Meats',
    logo: '/assets/images/logos/premium-meats.svg',
    type: 'Supplier',
  },
  {
    name: 'Green Market',
    logo: '/assets/images/logos/green-market.svg',
    type: 'Supplier',
  },
  {
    name: 'Fusion Delights',
    logo: '/assets/images/logos/fusion-delights.svg',
    type: 'Restaurant',
  },
];

// Testimonials data for the home page
export const testimonials = [
  {
    name: 'Sarah Johnson',
    role: 'Restaurant Owner',
    company: 'The Urban Bistro',
    avatar: '/assets/images/testimonials/avatar1.svg',
    content:
      "Cartify has revolutionized how we manage our supply chain. We've cut our ordering time by 70% and the transparency in pricing has helped us save significantly on costs.",
    rating: 5,
  },
  {
    name: 'Michael Chen',
    role: 'Operations Manager',
    company: 'Fresh Market Chain',
    avatar: '/assets/images/testimonials/avatar2.svg',
    content:
      'The streamlined communication with suppliers has eliminated so many back-and-forth emails. Our team can now focus on what matters most - serving our customers.',
    rating: 5,
  },
  {
    name: 'Emily Rodriguez',
    role: 'Head Chef',
    company: 'Coastal Kitchen',
    avatar: '/assets/images/testimonials/avatar3.svg',
    content:
      'Having real-time access to supplier inventory and pricing has made menu planning so much easier. Cartify has become an essential tool for our kitchen operations.',
    rating: 5,
  },
];

// Supplier-related data for the For Suppliers page
export const supplierBenefits = [
  {
    icon: 'solar:shop-2-bold-duotone',
    title: 'List Once, Reach Many',
    description:
      'Upload your products once and instantly reach thousands of restaurants across multiple platforms.',
    colorKey: 'primary', // Will be resolved to theme.palette.primary.main
  },
  {
    icon: 'solar:eye-bold-duotone',
    title: 'Enhanced Visibility',
    description: 'Get discovered by restaurants actively searching for suppliers in your category.',
    colorKey: 'info', // Will be resolved to theme.palette.info.main
  },
  {
    icon: 'solar:settings-bold-duotone',
    title: 'Automated Operations',
    description: 'Streamline order processing, inventory management, and customer communication.',
    colorKey: 'success', // Will be resolved to theme.palette.success.main
  },
  {
    icon: 'solar:cart-large-minimalistic-bold-duotone',
    title: 'Digital Ordering',
    description:
      'Receive orders digitally with real-time notifications and automated confirmations.',
    colorKey: 'warning', // Will be resolved to theme.palette.warning.main
  },
];

export const efficiencyMetrics = [
  {
    icon: 'solar:dollar-minimalistic-bold-duotone',
    title: 'Increase Sales',
    value: '40%',
    description: 'Average sales growth for suppliers on Cartify',
  },
  {
    icon: 'solar:clock-circle-bold-duotone',
    title: 'Save Time',
    value: '60%',
    description: 'Reduction in order processing time',
  },
  {
    icon: 'solar:users-group-rounded-bold-duotone',
    title: 'Expand Reach',
    value: '5x',
    description: 'More restaurants discover your products',
  },
  {
    icon: 'solar:chart-2-bold-duotone',
    title: 'Better Margins',
    value: '25%',
    description: 'Improved profitability through efficiency',
  },
];

export const supplierTestimonials = [
  {
    name: 'Sarah Chen',
    role: 'Food Distributor',
    company: 'FreshCo Supplies',
    content:
      'Cartify transformed our business. We now reach 3x more restaurants and our order processing is 70% faster.',
    avatar: '/assets/illustrations/characters/character_1.png',
    rating: 5,
  },
  {
    name: 'Marcus Rodriguez',
    role: 'Beverage Supplier',
    company: 'Premium Drinks Co.',
    content:
      'The automation features saved us hours every day. Our restaurant partners love the seamless ordering experience.',
    avatar: '/assets/illustrations/characters/character_2.png',
    rating: 5,
  },
  {
    name: 'Emma Thompson',
    role: 'Produce Supplier',
    company: 'Green Valley Farms',
    content:
      'Since joining Cartify, our monthly orders have doubled. The platform makes it so easy to manage everything.',
    avatar: '/assets/illustrations/characters/character_3.png',
    rating: 5,
  },
];

// Restaurant-specific data for the For Restaurants page
export const restaurantPainPoints = [
  {
    icon: 'solar:clock-circle-bold-duotone',
    title: 'Inconsistent Pricing',
    description:
      'Struggling with fluctuating prices from multiple suppliers that eat into your margins.',
    colorKey: 'error', // Will be resolved to theme.palette.error.main
  },
  {
    icon: 'solar:delivery-bold-duotone',
    title: 'Delayed Orders',
    description: 'Late deliveries causing customer dissatisfaction and operational chaos.',
    colorKey: 'warning', // Will be resolved to theme.palette.warning.main
  },
  {
    icon: 'solar:users-group-rounded-bold-duotone',
    title: 'Managing Multiple Suppliers',
    description: 'Complex coordination between different vendors leading to inefficiencies.',
    colorKey: 'info', // Will be resolved to theme.palette.info.main
  },
];

export const restaurantBenefits = [
  {
    icon: 'solar:chart-2-bold-duotone',
    title: 'Real-time Tracking',
    description:
      'Monitor your orders and inventory in real-time with our advanced tracking system.',
    colorKey: 'success', // Will be resolved to theme.palette.success.main
  },
  {
    icon: 'solar:dollar-minimalistic-bold',
    title: 'Better Margins',
    description: 'Optimize pricing and reduce costs with our intelligent supplier management.',
    colorKey: 'primary', // Will be resolved to theme.palette.primary.main
  },
  {
    icon: 'solar:shield-check-bold-duotone',
    title: 'Verified Suppliers',
    description: 'Partner with pre-vetted, reliable suppliers to ensure quality and consistency.',
    colorKey: 'secondary', // Will be resolved to theme.palette.secondary.main
  },
];

export const restaurantTestimonials = [
  {
    name: 'Sarah Chen',
    role: 'Owner, Fusion Bistro',
    avatar: '/assets/illustrations/characters/character_1.png',
    content:
      'Cartify transformed our supply chain. We now have consistent pricing and reliable deliveries that our customers love.',
    rating: 5,
  },
  {
    name: 'Marcus Rodriguez',
    role: 'Manager, Urban Kitchen',
    avatar: '/assets/illustrations/characters/character_2.png',
    content:
      'The real-time tracking feature alone has saved us countless hours. Our operations are now smooth and efficient.',
    rating: 5,
  },
  {
    name: 'Emma Thompson',
    role: 'Chef, Garden Cafe',
    avatar: '/assets/illustrations/characters/character_3.png',
    content:
      'Verified suppliers mean we never worry about quality. Cartify has become our trusted partner in success.',
    rating: 5,
  },
];

// Footer navigation data
export const FOOTER_LINKS = [
  {
    headline: 'CARTIFY',
    children: [
      { name: 'Home', href: '/', path: 'home' },
      { name: 'How It Works', href: '/how-it-works', path: 'howItWorks' },
      { name: 'For Restaurants', href: '/for-restaurants', path: 'forRestaurants' },
      { name: 'For Suppliers', href: '/for-suppliers', path: 'forSuppliers' },
      // { name: 'About Us', href: '/about-us', path: 'aboutUs' },
      { name: 'Features', href: '/features', path: 'features' },
      { name: 'Blog & News', href: '/blog', path: 'blog' },
      { name: 'FAQ', href: '/faq', path: 'faq' },
      { name: 'Contact Us', href: '/contact-us', path: 'contact' },
    ],
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Conditions', href: '/terms-and-conditions', path: 'termsAndConditions' },
      { name: 'Privacy Policy', href: '/privacy-policy', path: 'privacyPolicy' },
    ],
  },
];

// FAQ data
export const RESTAURANT_FAQS = [
  {
    question: 'How does Cartify help restaurants save time on procurement?',
    answer:
      'Cartify streamlines your entire procurement process by providing a single platform to compare suppliers, view real-time pricing, and place orders. This eliminates the need for multiple phone calls and emails, saving you hours every week.',
  },
  {
    question: 'What types of suppliers are available on Cartify?',
    answer:
      'We partner with 500+ verified suppliers covering all F&B categories including fresh produce, meat, dairy, beverages, dry goods, and specialty items. All suppliers are pre-vetted for quality and reliability.',
  },
  {
    question: 'How do I track my orders and deliveries?',
    answer:
      'Our real-time tracking system gives you complete visibility into your orders. You can track order status, delivery times, and receive automated notifications at every step of the process.',
  },
  {
    question: 'Is there a minimum order requirement?',
    answer:
      'Minimum order requirements vary by supplier, but we work with suppliers who offer flexible ordering options. You can place orders as needed without being locked into large minimum quantities.',
  },
  {
    question: 'How does Cartify ensure quality control?',
    answer:
      'We partner only with verified, reputable suppliers and provide detailed product information, reviews, and ratings. Our quality assurance team regularly monitors supplier performance.',
  },
  {
    question: 'What payment methods do you accept?',
    answer:
      'We accept all major credit cards, bank transfers, and offer flexible payment terms. You can also set up automatic payments for recurring orders to streamline your operations.',
  },
  {
    question: 'Can I customize my delivery schedule?',
    answer:
      "Yes, you can set custom delivery schedules based on your restaurant's needs. Many suppliers offer flexible delivery options including same-day, next-day, and scheduled deliveries.",
  },
];

export const SUPPLIER_FAQS = [
  {
    question: 'How can suppliers benefit from joining Cartify?',
    answer:
      'Cartify provides suppliers with access to thousands of restaurants, automated order processing, real-time inventory management, and detailed analytics to help grow your business and increase efficiency.',
  },
  {
    question: 'What is the onboarding process for suppliers?',
    answer:
      'Our onboarding process is simple: submit your business information, complete verification, set up your product catalog, and start receiving orders. Our team guides you through every step.',
  },
  {
    question: 'How does Cartify handle payments and invoicing?',
    answer:
      'We provide secure payment processing and automated invoicing. Suppliers receive payments on time with transparent fee structures and detailed financial reporting.',
  },
  {
    question: 'Can suppliers set their own pricing and terms?',
    answer:
      'Yes, suppliers maintain full control over their pricing, minimum orders, delivery schedules, and terms. You can update pricing in real-time and set custom delivery zones.',
  },
  {
    question: 'What analytics and insights are available to suppliers?',
    answer:
      'Suppliers get comprehensive analytics including order trends, customer insights, performance metrics, and market analysis to help optimize your business strategy.',
  },
  {
    question: 'How do you handle customer support for suppliers?',
    answer:
      'We provide dedicated support for suppliers including onboarding assistance, technical support, and business development guidance. Our team is available to help you succeed.',
  },
  {
    question: 'What are the commission rates for suppliers?',
    answer:
      'Our commission structure is transparent and competitive. We offer volume-based discounts and flexible terms to help suppliers maximize their profitability.',
  },
];
